import React from 'react';
import { useTheme } from 'emotion-theming';

const TwitterIcon = ({ color, ...props }) => {
    const theme = useTheme();
    const iconColor = color ? color : theme.colorMap.greyLightTwo;
    return (
        <svg
            aria-label="Twitter"
            width="20"
            height="20"
            viewBox="0 0 512 512"
            {...props}
        >
            <g>
                <path
                    fill={iconColor}
                    d="M512 97.209c-18.838 8.354-39.082 14.001-60.33 16.54 21.686-13 38.343-33.585 46.186-58.115-20.298 12.039-42.778 20.78-66.705 25.49-19.16-20.415-46.461-33.17-76.673-33.17-58.011 0-105.044 47.029-105.044 105.039 0 8.233 0.929 16.25 2.72 23.939-87.3-4.382-164.701-46.2-216.509-109.753-9.042 15.514-14.223 33.558-14.223 52.809 0 36.444 18.544 68.596 46.73 87.433-17.219-0.546-33.416-5.271-47.577-13.139-0.010 0.438-0.010 0.878-0.010 1.321 0 50.894 36.209 93.348 84.261 103-8.813 2.4-18.094 3.686-27.674 3.686-6.769 0-13.349-0.66-19.764-1.886 13.368 41.73 52.16 72.103 98.126 72.948-35.95 28.175-81.243 44.967-130.458 44.967-8.479 0-16.84-0.497-25.058-1.47 46.486 29.805 101.701 47.197 161.021 47.197 193.211 0 298.868-160.062 298.868-298.872 0-4.554-0.103-9.084-0.305-13.59 20.528-14.81 38.336-33.31 52.418-54.374z"
                />
            </g>
        </svg>
    );
};
export default TwitterIcon;
